var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem6 = function SvgProblem6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 172,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__a)",
    fillRule: "evenodd",
    d: "M89.602 2.864c-2.478 0-4.487 2.038-4.487 4.553s2.009 4.554 4.487 4.554 4.487-2.039 4.487-4.554-2.009-4.553-4.487-4.553m-7.31 4.553c0-4.096 3.273-7.417 7.31-7.417s7.31 3.32 7.31 7.417-3.273 7.418-7.31 7.418-7.31-3.321-7.31-7.418",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__b)",
    fillRule: "evenodd",
    d: "M77.862 160.029c-2.478 0-4.487 2.039-4.487 4.554s2.009 4.553 4.487 4.553 4.487-2.038 4.487-4.553-2.009-4.554-4.487-4.554m-7.31 4.554c0-4.097 3.273-7.418 7.31-7.418s7.31 3.321 7.31 7.418S81.898 172 77.861 172s-7.31-3.321-7.31-7.417",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__c)",
    fillRule: "evenodd",
    d: "M121.605 12.63c-2.479 0-4.488 2.038-4.488 4.553s2.009 4.553 4.488 4.553c2.478 0 4.487-2.038 4.487-4.553s-2.009-4.554-4.487-4.554m-7.31 4.553c0-4.097 3.273-7.417 7.31-7.417s7.309 3.32 7.309 7.417-3.273 7.417-7.309 7.417c-4.037 0-7.31-3.32-7.31-7.417",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__d)",
    fillRule: "evenodd",
    d: "M45.831 150.264c-2.478 0-4.487 2.038-4.487 4.553s2.009 4.554 4.487 4.554 4.487-2.039 4.487-4.554-2.009-4.553-4.487-4.553m-7.31 4.553c0-4.096 3.273-7.417 7.31-7.417s7.31 3.321 7.31 7.417c0 4.097-3.273 7.417-7.31 7.417s-7.31-3.32-7.31-7.417",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__e)",
    fillRule: "evenodd",
    d: "M147.427 36.37c-2.478 0-4.487 2.039-4.487 4.554 0 2.514 2.009 4.553 4.487 4.553s4.487-2.038 4.487-4.553-2.009-4.554-4.487-4.554m-7.309 4.554c0-4.097 3.272-7.417 7.309-7.417s7.309 3.32 7.309 7.417-3.272 7.417-7.309 7.417-7.309-3.32-7.309-7.417",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__f)",
    fillRule: "evenodd",
    d: "M20.009 126.551c-2.478 0-4.487 2.039-4.487 4.554s2.009 4.553 4.487 4.553 4.487-2.038 4.487-4.553-2.01-4.554-4.487-4.554m-7.31 4.554c0-4.097 3.273-7.417 7.31-7.417s7.309 3.32 7.309 7.417-3.273 7.417-7.31 7.417-7.308-3.321-7.308-7.417",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__g)",
    fillRule: "evenodd",
    d: "M160.691 68.989c-2.478 0-4.487 2.039-4.487 4.554 0 2.514 2.009 4.553 4.487 4.553s4.487-2.039 4.487-4.553c0-2.515-2.009-4.554-4.487-4.554m-7.31 4.554c0-4.097 3.273-7.418 7.31-7.418S168 69.446 168 73.543s-3.272 7.417-7.309 7.417-7.31-3.321-7.31-7.417",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__h)",
    fillRule: "evenodd",
    d: "M7.31 93.904c-2.479 0-4.488 2.039-4.488 4.554 0 2.514 2.01 4.553 4.487 4.553s4.487-2.039 4.487-4.553c0-2.515-2.009-4.554-4.487-4.554M0 98.458c0-4.097 3.272-7.418 7.31-7.418 4.036 0 7.309 3.321 7.309 7.417 0 4.097-3.273 7.418-7.31 7.418S0 102.554 0 98.457",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__i)",
    fillRule: "evenodd",
    d: "M157.643 106.562c-2.478 0-4.487 2.039-4.487 4.554 0 2.514 2.009 4.553 4.487 4.553s4.487-2.039 4.487-4.553c0-2.515-2.009-4.554-4.487-4.554m-7.309 4.554c0-4.097 3.272-7.418 7.309-7.418s7.309 3.321 7.309 7.418-3.272 7.417-7.309 7.417-7.309-3.321-7.309-7.417",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__j)",
    fillRule: "evenodd",
    d: "M10.385 56.331c-2.478 0-4.487 2.039-4.487 4.553 0 2.515 2.01 4.554 4.487 4.554 2.479 0 4.488-2.039 4.488-4.554 0-2.514-2.01-4.553-4.488-4.553m-7.309 4.553c0-4.096 3.273-7.417 7.31-7.417s7.309 3.321 7.309 7.417c0 4.097-3.273 7.418-7.31 7.418s-7.309-3.321-7.309-7.418",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__k)",
    fillRule: "evenodd",
    d: "M139.694 136.403c-2.478 0-4.487 2.039-4.487 4.553 0 2.515 2.009 4.554 4.487 4.554s4.487-2.039 4.487-4.554c0-2.514-2.009-4.553-4.487-4.553m-7.309 4.553c0-4.096 3.272-7.417 7.309-7.417s7.31 3.321 7.31 7.417c0 4.097-3.273 7.418-7.31 7.418s-7.309-3.321-7.309-7.418",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__l)",
    fillRule: "evenodd",
    d: "M28.306 26.49c-2.479 0-4.487 2.039-4.487 4.554 0 2.514 2.009 4.553 4.487 4.553s4.487-2.039 4.487-4.553c0-2.515-2.01-4.554-4.487-4.554m-7.31 4.554c0-4.097 3.273-7.418 7.31-7.418s7.309 3.321 7.309 7.418-3.273 7.417-7.31 7.417-7.308-3.32-7.308-7.417",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__m)",
    fillRule: "evenodd",
    d: "M111.755 154.96c-2.478 0-4.487 2.039-4.487 4.554s2.009 4.553 4.487 4.553 4.488-2.038 4.488-4.553-2.009-4.554-4.488-4.554m-7.309 4.554c0-4.097 3.273-7.417 7.309-7.417 4.037 0 7.31 3.32 7.31 7.417s-3.273 7.417-7.31 7.417-7.309-3.321-7.309-7.417",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__n)",
    fillRule: "evenodd",
    d: "M55.708 7.933c-2.478 0-4.487 2.038-4.487 4.553s2.01 4.554 4.487 4.554c2.479 0 4.488-2.039 4.488-4.554s-2.01-4.553-4.488-4.553M48.4 12.486c0-4.096 3.273-7.417 7.31-7.417s7.309 3.32 7.309 7.417-3.273 7.417-7.31 7.417-7.309-3.32-7.309-7.417",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__o)",
    fillRule: "evenodd",
    d: "M77.75 158.583 88.589 13.331l1.125.086L78.876 158.67z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__p)",
    fillRule: "evenodd",
    d: "m77.773 158.461 40.413-136.203 1.08.33-40.412 136.203z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__q)",
    fillRule: "evenodd",
    d: "M134.991 137.092 57.355 18.387l.94-.633 77.636 118.704z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__r)",
    fillRule: "evenodd",
    d: "M48.17 149.411 88.61 13.209l1.08.33-40.44 136.203z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__s)",
    fillRule: "evenodd",
    d: "M152.49 108.013 57.441 18.49l.768-.84 95.048 89.523z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__t)",
    fillRule: "evenodd",
    d: "M15.893 62.236 142.52 43.765l.16 1.134L16.053 63.37z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__u)",
    fillRule: "evenodd",
    d: "m24.444 127.284 93.864-105.245.837.769-93.864 105.245z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__v)",
    fillRule: "evenodd",
    d: "m142.813 44.863-129.45 53.18-.424-1.061L142.39 43.8z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__w)",
    fillRule: "evenodd",
    d: "m16.02 62.232 138.904 11.685-.093 1.141L15.927 63.374z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__x)",
    fillRule: "evenodd",
    d: "M133.884 135.383 32.147 35.637l.784-.824 101.737 99.746z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__y)",
    fillRule: "evenodd",
    d: "m16.146 62.258 136.901 44.79-.347 1.09-136.9-44.79z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__z)",
    fillRule: "evenodd",
    d: "m151.334 45.6 8.946 21.794-1.042.44-8.946-21.793z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__A)",
    fillRule: "evenodd",
    d: "m134.898 136.73 7.14-92.443 1.126.09-7.14 92.443z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__B)",
    fillRule: "evenodd",
    d: "m156.234 117.084-11.937 19.875-.964-.596 11.937-19.875z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__C)",
    fillRule: "evenodd",
    d: "m162.185 79.489-2.117 26.003-1.125-.094 2.117-26.003z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__D)",
    fillRule: "evenodd",
    d: "m127.148 19.68 17.299 15.893-.757.85-17.3-15.894z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__E)",
    fillRule: "evenodd",
    d: "M116.306 14.81 95.309 8.395l.326-1.097 20.996 6.415z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__F)",
    fillRule: "evenodd",
    d: "M83.809 8.933 61.26 10.909l-.097-1.141 22.549-1.976z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__G)",
    fillRule: "evenodd",
    d: "M50.52 15.138 32.74 27.252l-.629-.951 17.78-12.114z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__H)",
    fillRule: "evenodd",
    d: "M24.696 35.637 12.758 55.512l-.964-.596 11.938-19.875z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__I)",
    fillRule: "evenodd",
    d: "M9.057 66.602 6.94 92.605l-1.125-.094 2.117-26.003z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__J)",
    fillRule: "evenodd",
    d: "m8.766 104.177 8.41 21.793-1.051.418-8.41-21.794z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__K)",
    fillRule: "evenodd",
    d: "m23.774 135.577 17.3 15.895-.758.849-17.3-15.894z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__L)",
    fillRule: "evenodd",
    d: "m51.158 157.19 20.997 6.415-.326 1.097-20.996-6.415z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__M)",
    fillRule: "evenodd",
    d: "m106.335 162.228-22.492 3.38-.166-1.134 22.493-3.379z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__N)",
    fillRule: "evenodd",
    d: "m135.848 145.724-19.868 11.169-.547-1.002 19.867-11.169z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__O)",
    fillRule: "evenodd",
    d: "m58.351 17.864 51.814 135.859-1.053.413L57.299 18.277z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__P)",
    fillRule: "evenodd",
    d: "m16.444 62.488 62.34 95.822-.942.632-62.34-95.823z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__Q)",
    fillRule: "evenodd",
    d: "M58.315 18.355 13.641 97.796l-.98-.567 44.674-79.442z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__R)",
    fillRule: "evenodd",
    d: "m24.3 127.62 7.677-92.443 1.124.096-7.676 92.443z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__S)",
    fillRule: "evenodd",
    d: "M48.147 149.536 57.262 18.03l1.126.08-9.115 131.507z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__T)",
    fillRule: "evenodd",
    d: "M143.091 44.616 78.804 158.91l-.98-.568L142.11 44.048z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__U)",
    fillRule: "evenodd",
    d: "m133.717 135.051-15.55-112.548 1.118-.159 15.55 112.548z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__V)",
    fillRule: "evenodd",
    d: "m77.899 158.237 76.564-84.138.829.777-76.564 84.139z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__W)",
    fillRule: "evenodd",
    d: "m48.507 149.042 103.317-40.38.406 1.069-103.318 40.38z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__X)",
    fillRule: "evenodd",
    d: "m24.652 127.137 130.014-53.18.422 1.062L25.074 128.2z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__Y)",
    fillRule: "evenodd",
    d: "M135.291 137.321 12.981 98.059l.34-1.093 122.31 39.263z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__Z)",
    fillRule: "evenodd",
    d: "m89.709 13.29 20.488 140.556-1.117.167L88.592 13.458z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_6_svg__aa)",
    fillRule: "evenodd",
    d: "M109.168 154.245 32.068 35.54l.942-.63 77.1 118.704z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__a",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__b",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__c",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__d",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__e",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__f",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__g",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__h",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__i",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__j",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__k",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__l",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__m",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__n",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__o",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__p",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__q",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__r",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__s",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__t",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__u",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__v",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__w",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__x",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__y",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__z",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__A",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__B",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__C",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__D",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__E",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__F",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__G",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__H",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__I",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__J",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__K",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__L",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__M",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__N",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__O",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__P",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__Q",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__R",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__S",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__T",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__U",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__V",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__W",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__X",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__Y",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__Z",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_6_svg__aa",
    x1: 84,
    x2: 84,
    y1: 0,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem6;